import { render, staticRenderFns } from "./SSearchModal.vue?vue&type=template&id=8640ba44&scoped=true"
import script from "./SSearchModal.vue?vue&type=script&lang=js"
export * from "./SSearchModal.vue?vue&type=script&lang=js"
import style0 from "./SSearchModal.vue?vue&type=style&index=0&id=8640ba44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8640ba44",
  null
  
)

export default component.exports